import React, {Component} from 'react'

import Popup from '../Popup/index';

import Registry from '../../../registry/index';

import {BobTVSiteInterfaceError} from '../../../interfaces/site/index';

import {
    BLOCK_TYPE_24H,
    BLOCK_TYPE_PERMANENT
} from '../../../constants/block';

class BlockPopup extends Popup {
    constructor(props) {
        super(props);

        this.showOverlay = true;
        this.afterClosePositionReset = false;

        this.state = {
            error: '',
            reason: ''
        };

        this._onSuccess = this._onSuccess.bind(this);
        this._onError = this._onError.bind(this);
    }

    block(user, type) {
        const { reason } = this.state;

        let siteInterface = Registry.get('siteInterface');
        siteInterface.block(user, reason, type).then(this._onSuccess).catch(this._onError);
    }

    _afterClose() {
        this.setState({
            error: '',
            reason: ''
        });
    }

    _onSuccess(_response) {
        // console.log('BlockPopup._onSuccess', _response);
        this.close();
    }

    /**
     * @param {Error|BobTVSiteInterfaceError} exception
     * @private
     */
    _onError(exception) {
        let errorMessage = exception instanceof BobTVSiteInterfaceError ? exception.message : Registry.get('locale')['site_interface_generic_error'];
        this.setState({error: errorMessage});

        // console.log('BlockPopup._onError', Object.create(exception), exception instanceof BobTVSiteInterfaceError, exception instanceof Error);
    }

    render() {
        let lang = Registry.get('locale');

        let {user} = this.props;

        let className = 'popup popup-block-confirmation ' + this.state.visibility;

        return (
            <div className={className} ref={(ref) => this._ref = ref}>
                <p className="desc" dangerouslySetInnerHTML={{__html:lang.block_confirm(user)}}></p>
                <p className="error">{this.state.error}</p>
                <textarea 
                    placeholder={lang.block_placeholder}
                    onChange={(event) => this.setState({reason: event.target.value})}
                    value={this.state.reason}
                />
                <a href="#" className="popup-button 24h" onClick={() => this.block(user, BLOCK_TYPE_24H)}>{lang.block_24h}</a>
                <a href="#" className="popup-button permanent" onClick={() => this.block(user, BLOCK_TYPE_PERMANENT)}>{lang.block_permanent}</a>
                <a href="#" className="popup-button no" onClick={() => this.close()}>{lang.no}</a>
             </div>
        )
    }

}

BlockPopup.generateKey = function() { return 'block-popup' };
BlockPopup.mount = function(props, onMount) { return Popup.mount(BlockPopup, props, onMount) };
BlockPopup.open = function(props) {
    BlockPopup.mount(props, () => {  Popup.popups[BlockPopup.generateKey(props)].open(); } );
   
};

export default BlockPopup;


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/BlockPopup/index.js